import { render, staticRenderFns } from "./MandalaEvaluationModalBody.vue?vue&type=template&id=7520b10c&scoped=true&"
import script from "./MandalaEvaluationModalBody.vue?vue&type=script&lang=js&"
export * from "./MandalaEvaluationModalBody.vue?vue&type=script&lang=js&"
import style0 from "./MandalaEvaluationModalBody.vue?vue&type=style&index=0&id=7520b10c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7520b10c",
  null
  
)

export default component.exports